// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-74[data-v-fab748a4] {\n  width: 74%;\n}", ""]);
// Exports
module.exports = exports;
